export default __webpack_public_path__ + "static/media/screenshot1_sm.372333a7.jpg";